// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"1b42e73a","491":"e7f49417"}[chunkId] + ".css";
};